module.exports = __webpack_public_path__ + "static/img/user_bg.462cf7ab.png";